import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import TX from '@Components/Common/Text';

import { ReactComponent as WarningSVG } from '@Assets/Svgs/ic_warning.svg';
import { ReactComponent as EmptyPageSVG } from '@Assets/Svgs/ic_page_empty.svg';

const PageItem = ({ pageId, pageText, selectedProcessId, processIdsByValidationPassed, handlePageItemPress }) => {
  // console.log('selectedProcessId:', selectedProcessId);
  const isSelected = selectedProcessId === pageId;
  const isValidationNotPassed = !processIdsByValidationPassed.includes(pageId);

  return (
    <PageItemContainer
      isSelected={isSelected}
      isValidationNotPassed={isValidationNotPassed}
      onClick={() => handlePageItemPress(pageId)}
    >
      <PageId isRed={isValidationNotPassed} isSelected={isSelected}>
        {pageId}
      </PageId>
      <PageText isRed={isValidationNotPassed} isSelected={isSelected}>
        {pageText || '빈 페이지'}
      </PageText>
      <RightIconContainer>
        {isValidationNotPassed && pageText === '' && <EmptyPagIcon />}
        {isValidationNotPassed && pageText !== '' && <NonCompletionNoticeIcon />}
      </RightIconContainer>
    </PageItemContainer>
  );
};

PageItem.propTypes = {
  pageId: PropTypes.number.isRequired,
  pageText: PropTypes.string.isRequired,
  selectedProcessId: PropTypes.number.isRequired,
  processIdsByValidationPassed: PropTypes.arrayOf(PropTypes.number).isRequired,
  handlePageItemPress: PropTypes.func.isRequired,
};

const FlexAlignCenterLi = styled.li`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0px 16px;
`;

const PageItemContainer = styled(FlexAlignCenterLi)`
  width: 100%;
  height: 36px;
  position: relative;
  padding: ${({ isValidationNotPassed }) => (isValidationNotPassed ? '10px 44px 10px 24px' : '10px 24px 10px 24px')};
  cursor: pointer;
  align-items: center;

  background-color: ${({ isSelected, theme }) => {
    if (isSelected) {
      return theme.colors.ui_3;
    }

    return 'transparent';
  }};
`;

const RightIconContainer = styled.div`
  position: absolute;
  right: 24px;
  top: 7px;
  align-items: center;
`;

const NonCompletionNoticeIcon = styled(WarningSVG)`
  width: 16px;
  height: 16px;

  fill: ${({ theme }) => theme.colors.danger};
  & path {
    fill: ${({ theme }) => theme.colors.danger} !important;
    opacity: ${({ opacity }) => opacity} !important;
  }
`;

const EmptyPagIcon = styled(EmptyPageSVG)`
  width: 16px;
  height: 16px;

  fill: ${({ theme }) => theme.colors.danger};
`;

const PageId = styled(TX.FootnoteB)`
  user-select: none;
  color: ${({ theme }) => theme.colors.ui_on_3};
  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      font-weight: ${theme.fontWeights.bold};
      color: ${theme.colors.ui_on_1};
    `};

  // color: ${({ isRed, theme }) => (isRed ? theme.colors.danger : theme.colors.ui_on_2)};
`;

const PageText = styled(TX.Caption1)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  user-select: none;
  color: ${({ theme }) => theme.colors.ui_on_3};

  // color: ${({ isRed, theme }) => (isRed ? theme.colors.danger : theme.colors.ui_on_3)};

  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      font-weight: ${theme.fontWeights.bold};
      color: ${theme.colors.ui_on_1};
    `};
`;

export default PageItem;
